const STORAGE_KEY = 'doo:support-desk:saved:v1';

function readSaved() {
  try {
    const parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
}

function writeSaved(items) {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    return true;
  } catch (error) {
    return false;
  }
}

function escapeText(value) {
  const node = document.createElement('span');
  node.textContent = value;
  return node.innerHTML;
}

function escapeAttribute(value) {
  return escapeText(value).replaceAll('"', '&quot;').replaceAll("'", '&#39;');
}

function updateSavedUI(root = document) {
  const items = readSaved();
  const ids = new Set(items.map((item) => String(item.id)));

  root.querySelectorAll('[data-doo-save]').forEach((button) => {
    const active = ids.has(String(button.dataset.saveId));
    button.setAttribute('aria-pressed', String(active));
    const label = button.querySelector('[data-doo-save-label]');
    if (label) label.textContent = active ? 'Saved' : 'Save';
  });

  document.querySelectorAll('[data-doo-saved-count]').forEach((count) => {
    count.textContent = String(items.length);
  });

  document.querySelectorAll('[data-doo-saved-list]').forEach((list) => {
    list.innerHTML = items
      .map((item) => {
        const safeUrl = String(item.url || '').startsWith('/') ? item.url : '#';
        return `
          <li class="doo-saved-dialog__item">
            <a href="${escapeAttribute(safeUrl)}">${escapeText(item.title)}</a>
            <button class="doo-saved-dialog__remove" type="button" data-doo-remove-saved="${escapeAttribute(String(item.id))}">Remove</button>
          </li>`;
      })
      .join('');
  });

  document.querySelectorAll('[data-doo-saved-empty]').forEach((empty) => {
    empty.hidden = items.length > 0;
  });
}

function toggleSaved(button) {
  const item = {
    id: String(button.dataset.saveId || ''),
    title: button.dataset.saveTitle || 'Saved method',
    url: button.dataset.saveUrl || window.location.pathname,
  };

  if (!item.id) return;

  const items = readSaved();
  const index = items.findIndex((saved) => String(saved.id) === item.id);
  if (index >= 0) items.splice(index, 1);
  else items.unshift(item);

  writeSaved(items.slice(0, 50));
  updateSavedUI();
}

function buildTableOfContents(root) {
  root.querySelectorAll('[data-doo-article-content]').forEach((content) => {
    const articleRoot = content.closest('[data-doo-support-root]');
    const list = articleRoot?.querySelector('[data-doo-toc-list]');
    const toc = articleRoot?.querySelector('[data-doo-toc]');
    if (!list || !toc) return;

    const headings = [...content.querySelectorAll('h2')];
    if (headings.length < 2) {
      toc.hidden = true;
      return;
    }

    const used = new Set();
    list.innerHTML = '';
    headings.forEach((heading, index) => {
      let id = heading.id || heading.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
      if (!id) id = `section-${index + 1}`;
      let uniqueId = id;
      let suffix = 2;
      while (used.has(uniqueId) || (document.getElementById(uniqueId) && document.getElementById(uniqueId) !== heading)) {
        uniqueId = `${id}-${suffix++}`;
      }
      used.add(uniqueId);
      heading.id = uniqueId;

      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${uniqueId}`;
      link.textContent = heading.textContent;
      item.appendChild(link);
      list.appendChild(item);
    });
  });
}

async function copyShortAnswer(button) {
  const root = button.closest('[data-doo-support-root]');
  const source = root?.querySelector('[data-doo-short-answer]');
  if (!source) return;

  try {
    await navigator.clipboard.writeText(source.textContent.trim());
    const original = button.textContent;
    button.textContent = 'Copied';
    window.setTimeout(() => { button.textContent = original; }, 1600);
  } catch (error) {
    // Clipboard permission can be unavailable in theme preview; printing still works.
  }
}

function bind(root = document) {
  if (root.dataset?.dooSupportBound === 'true') return;
  if (root.dataset) root.dataset.dooSupportBound = 'true';

  root.addEventListener('click', (event) => {
    const save = event.target.closest('[data-doo-save]');
    if (save) {
      event.preventDefault();
      toggleSaved(save);
      return;
    }

    const remove = event.target.closest('[data-doo-remove-saved]');
    if (remove) {
      const items = readSaved().filter((item) => String(item.id) !== String(remove.dataset.dooRemoveSaved));
      writeSaved(items);
      updateSavedUI();
      return;
    }

    const open = event.target.closest('[data-doo-open-saved]');
    if (open) {
      const dialog = document.querySelector('[data-doo-saved-dialog]');
      if (dialog?.showModal) dialog.showModal();
      return;
    }

    const close = event.target.closest('[data-doo-close-saved]');
    if (close) {
      close.closest('dialog')?.close();
      return;
    }

    if (event.target.closest('[data-doo-print]')) {
      window.print();
      return;
    }

    const copy = event.target.closest('[data-doo-copy-short-answer]');
    if (copy) copyShortAnswer(copy);
  });

  updateSavedUI(root);
  buildTableOfContents(root);
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bind(document));
else bind(document);

document.addEventListener('shopify:section:load', (event) => {
  updateSavedUI(event.target);
  buildTableOfContents(event.target);
});
